import { CheckCircle2, Clock, Download, Loader2, MessageCircle, XCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLang, waLink, formatIDR } from "@/lib/site";
import { copy } from "@/lib/content";

const ICONS = {
  creating: <Loader2 className="animate-spin text-amber-300" size={36} />,
  checking: <Loader2 className="animate-spin text-amber-300" size={36} />,
  paid: <CheckCircle2 className="text-emerald-400" size={36} />,
  pending: <Clock className="text-amber-300" size={36} />,
  failed: <XCircle className="text-rose-400" size={36} />,
  error: <XCircle className="text-rose-400" size={36} />,
};

export const PurchaseDialog = ({ p }) => {
  const { lang } = useLang();
  const t = copy[lang].pay;
  const msg = t[p.phase] ?? t.creating;
  const orderId = p.order?.order_id;
  const download = p.order?.download_url;
  return (
    <Dialog open={p.open} onOpenChange={(o) => !o && p.close()}>
      <DialogContent data-testid="purchase-dialog" className="border-amber-200/20 bg-[#0B1020] text-slate-100 sm:max-w-md rounded-3xl">
        <div className="flex flex-col items-center text-center gap-4 py-2">
          {ICONS[p.phase] ?? ICONS.creating}
          <DialogTitle className="font-display text-3xl font-medium text-slate-50">{msg.title}</DialogTitle>
          <DialogDescription data-testid="purchase-dialog-message" className="text-slate-300 text-sm leading-relaxed">{msg.body}</DialogDescription>
          {p.title && <p className="font-display italic text-xl text-gold">{p.title}{p.order?.amount ? ` · ${formatIDR(p.order.amount)}` : ""}</p>}
          {orderId && <p data-testid="purchase-order-id" className="font-mono text-xs text-slate-400">{t.orderLabel}: {orderId}</p>}
          {p.phase === "paid" && download && (
            <a data-testid="purchase-download-link" href={download} target="_blank" rel="noopener noreferrer" className="btn-gold inline-flex items-center gap-2 rounded-full px-6 py-3 font-semibold">
              <Download size={16} />{t.download}
            </a>
          )}
          {p.phase === "pending" && orderId && (
            <button data-testid="purchase-recheck-button" onClick={() => p.check(orderId)} className="btn-gold rounded-full px-6 py-3 font-semibold">{t.recheck}</button>
          )}
          {(p.phase === "paid" || p.phase === "failed" || p.phase === "error") && (
            <a data-testid="purchase-whatsapp-link" href={waLink(t.wa(p.title, orderId || "-"))} target="_blank" rel="noopener noreferrer"
              className="btn-ghost inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm">
              <MessageCircle size={16} className="text-amber-300" />{p.phase === "paid" && !download ? t.askFile : t.help}
            </a>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
